import { indexByProp } from '../../../utils/global';
import { createReducer } from '../../../utils/ReduxUtils';
import * as types from '../actionTypes';

const initialState = {
  isFetching: false,
  apiError: null,
  select: {
    links: {},
    page: { size: 20 },
    search: '',
  },
};

const isFetching = (state, { payload }) => ({
  ...state,
  isFetching: true,
  apiError: null,
  select: {
    ...state.select,
    search: payload.search,
  },
});

const fetchingFailed = (state, { payload }) => ({
  ...state,
  isFetching: false,
  apiError: payload.error,
});

const fetchingSucceeded = state => ({
  ...state,
  isFetching: false,
  apiError: null,
});

const fetchingPageSucceeded = (state, { payload }) => {
  const links = indexByProp('rel', payload.links);
  return {
    ...state,
    isFetching: false,
    apiError: null,
    select: {
      ...state.select,
      links: { ...links },
      page: payload.page,
    },
  };
};

const isUpdating = state => ({
  ...state,
  isFetching: true,
  apiError: null,
});

const updatingFailed = (state, { payload }) => ({
  ...state,
  isFetching: false,
  apiError: payload.error,
});

const updatingSucceeded = state => ({
  ...state,
  isFetching: false,
  apiError: null,
});

const clearIdsAndSearchReducer = state => ({
  ...state,
  select: {
    ...state.select,
    search: '',
  },
});

export default createReducer(initialState, {
  [types.FETCH_USER_GROUPS_REQUEST]: isFetching,
  [types.FETCH_USER_GROUPS_SUCCESS]: fetchingSucceeded,
  [types.FETCH_USER_GROUPS_FAILURE]: fetchingFailed,

  [types.FETCH_SELECTED_USER_GROUPS_REQUEST]: isFetching,
  [types.FETCH_SELECTED_USER_GROUPS_SUCCESS]: fetchingPageSucceeded,
  [types.FETCH_SELECTED_USER_GROUPS_FAILURE]: fetchingFailed,

  [types.UPDATE_USER_GROUPS_REQUEST]: isUpdating,
  [types.UPDATE_USER_GROUPS_SUCCESS]: updatingSucceeded,
  [types.UPDATE_USER_GROUPS_FAILURE]: updatingFailed,

  [types.CLEAR_USER_GROUP_SELECT]: clearIdsAndSearchReducer,
});
